import { companyPropertiesApi } from 'app/services/api';
import _ from 'lodash';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { selectIsMasterCompany, selectMasterCompanyId } from 'store/auth/selectors';

import { COMPANY_PROPERTIES_ACTION_TYPE } from './properties.actions';

export const COMPANY_PROPERTIES_NEW_ACTION_TYPE = createNamedActions('companyPropertiesNew', {
  GET_COMPANY_PROPERTIES: 'GET_COMPANY_PROPERTIES',
  SETTLE_COMPANY_PROPERTIES: 'SETTLE_COMPANY_PROPERTIES',
  SAVE_COMPANY_PROPERTY: 'SAVE_COMPANY_PROPERTY',
  REMOVE_COMPANY_PROPERTY: 'REMOVE_COMPANY_PROPERTY',
});

// Failure sentinel — see companyPropertiesSettled.reducer.js for why settlement is
// tracked separately from the data slice.
export const settleCompanyPropertiesAction = companyId => ({
  type: COMPANY_PROPERTIES_NEW_ACTION_TYPE.SETTLE_COMPANY_PROPERTIES,
  payload: { companyId },
});

export const getCompanyPropertiesAction = catchAsyncActionError(
  params => async (dispatch, getState) => {
    const state = getState();

    // AutoLogin clears the previous session before DefaultLayout's load effect runs, so a fetch
    // dispatched for the old master company can land with no master company at all. Falling
    // through to the internal route then 403s for any user without the internal claim; the
    // effect re-dispatches once the new session's master company is set.
    if (_.isNil(selectMasterCompanyId(state))) {
      return null;
    }

    const isMasterCompany = selectIsMasterCompany(params.companyId)(state);

    const { data } = await (isMasterCompany
      ? companyPropertiesApi.getCompanyProperties()
      : companyPropertiesApi.getCompanyPropertiesInternal(params));

    return dispatch({
      type: COMPANY_PROPERTIES_NEW_ACTION_TYPE.GET_COMPANY_PROPERTIES,
      payload: { companyId: params.companyId, items: data },
    });
  },
);

export const saveCompanyPropertyAction = catchAsyncActionError(
  params => async (dispatch, getState) => {
    const isMasterCompany = selectIsMasterCompany(params.companyId)(getState());

    const { data } = await (isMasterCompany
      ? companyPropertiesApi.createCompanyProperty(params)
      : companyPropertiesApi.createCompanyPropertyInternal(params));

    dispatch({
      type: COMPANY_PROPERTIES_NEW_ACTION_TYPE.SAVE_COMPANY_PROPERTY,
      payload: { ...data, companyId: params.companyId },
    });

    return dispatch({
      type: COMPANY_PROPERTIES_ACTION_TYPE.ADD_PROPERTY,
      payload: {
        companyId: params.companyId,
        propertyName: data.propertyName,
        propertyValue: data.propertyValue,
      },
    });
  },
);

export const removeCompanyPropertyAction = catchAsyncActionError(
  params => async (dispatch, getState) => {
    const isMasterCompany = selectIsMasterCompany(params.companyId)(getState());

    await (isMasterCompany
      ? companyPropertiesApi.deleteCompanyProperty(params)
      : companyPropertiesApi.deleteCompanyPropertyInternal(params));

    dispatch({
      type: COMPANY_PROPERTIES_NEW_ACTION_TYPE.REMOVE_COMPANY_PROPERTY,
      payload: {
        companyId: params.companyId,
        propertyName: params.propertyName,
      },
    });

    return dispatch({
      type: COMPANY_PROPERTIES_ACTION_TYPE.REMOVE_PROPERTY,
      payload: {
        companyId: params.companyId,
        propertyName: params.propertyName,
      },
    });
  },
);
